export const INTEGRATION_TYPE = 'salesforce-marketing-cloud-outbound'
export const DATA_TYPE_KEY = 'data_type'

export const DATA_TYPES = [
  { type: 'assets', label: 'Assets' },
  { type: 'campaigns', label: 'Campaigns' },
  { type: 'journeys', label: 'Journeys' },
] as const
